import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import reportWebVitals from './components/.shared/reportWebVitals';
import { SourceRedirect } from './utils/SourceRedirect';
import { SourceProvider } from './utils/sourceContext';
import { UserEngagementProvider } from './utils/userEngagementContext';
import { InterviewProvider } from './utils/interviewContext';
import { PostHogTracker } from './components/PostHogTracker/PostHogTracker';
import { TidioPosthogBridge } from './utils/tidioPosthogBridge';
import { ConsentGuard } from './utils/ConsentGuard';

import './index.css';
import 'animate.css';
import Privacy from './components/Privacy/Privacy';
import Terms from './components/Terms/Terms';
import CookiePolicyPage from './components/CookiePolicy/CookiePolicy';
import SuccessStoriesPage from './components/SuccessStories/SuccessStories';
import Contact from './components/ContactUs/Contact';
import Welcome from './components/Welcome/Welcome';
import CheckIn from './components/CheckIn/CheckIn';
import Intake from './components/Intake/Intake';
import ArticlesPage from './components/Articles/Articles';
import Landing from './components/Landing/Landing';
import SafeAdsLanding from './components/Landing/SafeAdsLanding';
import KnowledgeCenter from './components/KnowledgeCenter/KnowledgeCenter';
import AboutUs from './components/AboutUs/AboutUs';
import Login from './components/Login/Login';
import Patients from './components/Patients/Patients';
import Programs from './components/Programs/Programs';
import Checkout from './components/Checkout/Checkout';
import PaymentSuccess from './components/PaymentSuccess/PaymentSuccess';
import Billing from './components/Billing/Billing';
import Result from './components/Result/Result';
import Decision from './components/Interview/Decision';
import InterviewHeightWeight from './components/Interview/InterviewHeightWeight';
import InterviewBestYou from './components/Interview/InterviewBestYou';
import InterviewPriority from './components/Interview/InterviewPriority';
import ProgramsV2 from './components/ProgramsV2/ProgramsV2';

const App = () => {
  return (
    <InterviewProvider>
      <UserEngagementProvider>
          <BrowserRouter>
            <SourceProvider>
              <SourceRedirect />
              <PostHogTracker />
              <TidioPosthogBridge />
              <ConsentGuard>
                <Routes>
                  <Route path="login" element={<Login />} />
                  <Route path="patients" element={<Patients />} />
                  <Route path="privacy" element={<Privacy />} />
                  <Route path="terms" element={<Terms />} />
                  <Route path="packages" element={<Programs />} />
                  <Route path="products" element={<Programs />} />
                  <Route path="programs" element={<Programs />} />
                  <Route path="programs-v2" element={<ProgramsV2 />} />
                  <Route path="articles" element={<ArticlesPage />} />
                  <Route path="success-stories" element={<SuccessStoriesPage />} />
                  <Route path="contact" element={<Contact />} />
                  <Route path="welcome" element={<Welcome />} />
                  <Route path="checkout" element={<Navigate to="/checkout/payment" replace />} />
                  <Route path="checkout/payment" element={<Checkout />} />
                  <Route path="checkout/contact" element={<Navigate to="/checkout/payment" replace />} />
                  <Route path="payment-success" element={<PaymentSuccess />} />
                  <Route path="intake" element={<Intake />} />
                  <Route path="checkin" element={<CheckIn />} />
                  <Route path="start" element={<Programs />} />
                  <Route path="interview/" element={<Decision />} />
                  <Route path="interview/height-weight" element={<InterviewHeightWeight />} />
                  <Route path="interview/bestyou" element={<InterviewBestYou />} />
                  <Route path="interview/priority" element={<InterviewPriority />} />
                  <Route path="result" element={<Result />} />
                  <Route path="research" element={<KnowledgeCenter />} />
                  <Route path="safety" element={<KnowledgeCenter />} />
                  <Route path="faq" element={<KnowledgeCenter />} />
                  <Route path="research-center" element={<KnowledgeCenter />} />
                  <Route path="safety-center" element={<KnowledgeCenter />} />
                  <Route path="knowledge-center" element={<KnowledgeCenter />} />
                  <Route path="about" element={<AboutUs />} />
                  <Route path="about-us" element={<AboutUs />} />
                  <Route path="billing" element={<Billing />} />
                  <Route path="landing" element={<Landing />} />
                  <Route path="cookie-policy" element={<CookiePolicyPage />} />
                  <Route path="medical-weight-loss" element={<SafeAdsLanding />} />
                  <Route path="online-evaluation" element={<SafeAdsLanding />} />
                  <Route path="treatment-pricing" element={<SafeAdsLanding />} />
                  <Route path="*" element={<Landing />} />
                </Routes>
              </ConsentGuard>
            </SourceProvider>
          </BrowserRouter>
      </UserEngagementProvider>
    </InterviewProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals(console.log);
